import { render } from "./AiAgent.vue?vue&type=template&id=68135201&scoped=true"
import script from "./AiAgent.vue?vue&type=script&lang=js"
export * from "./AiAgent.vue?vue&type=script&lang=js"

import "./AiAgent.vue?vue&type=style&index=0&id=68135201&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68135201"]])

export default __exports__